<div class="px-3 py-5 text-center" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div class="px-3 pt-2" *ngIf="!loading">
  <div class="form-group">
    <div (click)="matter.use_case_name = !matter.use_case_name" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="use_case_name" [(ngModel)]="matter.use_case_name" [checked]="matter.use_case_name" />
      <label class="custom-control-label">Automatic Case Name</label>
    </div>
    <br />
    <label *ngIf="!matter.use_case_name">Custom Name</label>
    <input type="text" class="form-control" [(ngModel)]="matter.custom_name" *ngIf="!matter.use_case_name" />
    <h5 *ngIf="matter.use_case_name">{{ matter.case_name }}</h5>
  </div>
  <div class="form-group">
    <label>Started</label>
    <input type="text" class="form-control" [(ngModel)]="matter.started_on" [appDatepicker]="matter.started_on" (dateSelected)="matter.started_on = $event" />
  </div>
  <div class="form-group">
    <label>Type</label>
    <select class="form-control" [(ngModel)]="matter.matter_type_id" (change)="updateRateTypes()">
      <option *ngFor="let matter_type of formOptions.matter_types" [value]="matter_type.value">{{ matter_type.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <label>Rate Type</label>
    <select class="form-control" [(ngModel)]="matter.rate_type_id">
      <option *ngFor="let rate_type of formOptions.rate_types" [value]="rate_type.value">{{ rate_type.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <label>Status</label>
    <select class="form-control" [(ngModel)]="matter.matter_status_id">
      <option *ngFor="let matter_status of formOptions.matter_statuses" [value]="matter_status.value">{{ matter_status.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <label>File Location</label>
    <select class="form-control" [(ngModel)]="matter.file_location_id">
      <option *ngFor="let file_location of formOptions.file_locations" [value]="file_location.value">{{ file_location.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <label>Referral Type</label>
    <select class="form-control" [(ngModel)]="matter.referral_type_id">
      <option *ngFor="let referral_type of formOptions.referral_types" [value]="referral_type.value">{{ referral_type.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <label>Referral Percent</label>
    <input type="number" class="form-control" min="0" [(ngModel)]="matter.referral_percent" />
  </div>
  <div class="form-group">
    <label>Parent Matter</label>
    <app-matter-search (clearMatter)="matter.parent_matter_id = null" [matterId]="matter.parent_matter_id" (matter_id)="matter.parent_matter_id = $event"></app-matter-search>
  </div>
  <div class="form-group">
    <label>Jurisdiction</label>
    <input type="text" class="form-control" [(ngModel)]="matter.jurisdiction" />
  </div>
  <div class="form-group">
    <label>Default Appointment Address</label>
    <select class="form-control" [(ngModel)]="matter.default_appointment_address_id">
      <option *ngFor="let address of formOptions.default_appointment_addresses" [value]="address.value">{{ address.label }}</option>
    </select>
  </div>
  <div class="form-group">
    <div (click)="matter.auto_pay_from_escrow = !matter.auto_pay_from_escrow" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="auto_pay_from_escrow" [(ngModel)]="matter.auto_pay_from_escrow" [checked]="matter.auto_pay_from_escrow" />
      <label class="custom-control-label">Auto Pay from Escrow</label>
    </div>
    <br />
    <div (click)="matter.do_invoice = !matter.do_invoice" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="do_invoice" [(ngModel)]="matter.do_invoice" [checked]="matter.do_invoice" />
      <label class="custom-control-label">Do Invoice</label>
    </div>
    <br />
    <div (click)="matter.email_invoice = !matter.email_invoice" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="email_invoice" [(ngModel)]="matter.email_invoice" [checked]="matter.email_invoice" />
      <label class="custom-control-label">Email Invoice</label>
    </div>
  </div>
  <div class="form-group">
    <label>Billing Method</label>
    <select class="form-control" [(ngModel)]="matter.billing_method">
      <option value="traditional">Traditional (V7)</option>
      <option value="lawpay">LawPay</option>
      <option value="payload">PayLoad</option>
    </select>
    <small class="form-text text-muted" *ngIf="matter.billing_method === 'lawpay'">
      Invoices will be created and sent via LawPay for online payment.
    </small>
    <small class="form-text text-muted" *ngIf="matter.billing_method === 'payload'">
      Invoices will use PayLoad invoice links for online payment.
    </small>
  </div>
  <div class="form-group" *ngIf="matter.billing_method === 'lawpay'">
    <label>LawPay Deposit Account</label>
    <select class="form-control" [(ngModel)]="matter.lawpay_bank_account_override_id">
      <option [ngValue]="null">Automatic - operating LawPay account</option>
      <option *ngFor="let ba of formOptions.lawpay_bank_accounts" [ngValue]="ba.value">{{ ba.label }}</option>
    </select>
    <small class="form-text text-muted">
      Select an escrow LawPay account when the payment should deposit to trust/IOLTA.
    </small>
  </div>
  <div class="form-group">
    <div (click)="matter.is_uncollectable = !matter.is_uncollectable" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="is_uncollectable" [(ngModel)]="matter.is_uncollectable" [checked]="matter.is_uncollectable" />
      <label class="custom-control-label">Balance is uncollectable</label>
    </div>
    <br />
    <div (click)="matter.in_collections = !matter.in_collections" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="in_collections" [(ngModel)]="matter.in_collections" [checked]="matter.in_collections" />
      <label class="custom-control-label">Account is in collections</label>
    </div>
    <br />
    <div (click)="matter.court_appointed = !matter.court_appointed" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="court_appointed" [(ngModel)]="matter.court_appointed" [checked]="matter.court_appointed" />
      <label class="custom-control-label">Court appointed</label>
    </div>
    <br />
    <div (click)="matter.pro_bono = !matter.pro_bono" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="pro_bono" [(ngModel)]="matter.pro_bono" [checked]="matter.pro_bono" />
      <label class="custom-control-label">Pro bono</label>
    </div>
  </div>
  <div class="form-group">
    <label
      >Existing Tags:&nbsp;<span *ngFor="let tag of matter.tag_list"
        ><app-badge badgeType="primary">{{ tag }}</app-badge
        >&nbsp;</span
      ></label
    >
    <br />
    <label>New Tags</label>
    <input type="text" class="form-control" [(ngModel)]="matter.new_tags" placeholder="comma delimited" />
  </div>
  <div class="form-group">
    <label>Notice</label>
    <textarea class="form-control" [(ngModel)]="matter.notice"></textarea>
  </div>
  <div class="form-group">
    <label>Notes</label>
    <textarea class="form-control" [(ngModel)]="matter.notes"></textarea>
  </div>
  <div class="form-group">
    <div (click)="matter.is_private = !matter.is_private" class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" name="is_private" [(ngModel)]="matter.is_private" [checked]="matter.is_private" />
      <label class="custom-control-label">Private (only matter users can view)</label>
    </div>
  </div>
  <div class="form-group text-center">
    <button type="button" class="btn btn-primary" (click)="saveMatter()" [disabled]="formSubmitting">
      {{ formSubmitting ? 'Saving' : 'Save' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
    </button>
  </div>
</div>
